<template>
  <div class="group-listing">
    <v-row>
      <v-col class="px-4 px-md-0">
        <v-card-title
          class="display-2 letter-spacing-compact font-weight-bold mb-md-12 align-center px-md-5 black--text"
        >
          {{ request.id ? 'Edit' : 'New' }} Project
        </v-card-title>
      </v-col>
    </v-row>

    <validation-observer ref="validator">
      <v-form @submit.prevent="submit()">
        <v-container fluid class="mx-1060">
          <v-row>
            <v-col cols="12" class="pr-md-7" :lg="rightDrawer.opened ? 12 : 6">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  class=""
                  name="name"
                  :error-messages="errors"
                  v-model="request.name"
                  label="Project Name"
                  required
                />
              </ValidationProvider>
            </v-col>
            <v-col cols="12" class="pr-md-7" :lg="rightDrawer.opened ? 12 : 6">
              <LocationField
                name="location"
                v-model="request.location"
                :required="true"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pr-md-7" :lg="rightDrawer.opened ? 12 : 6">
              <ValidationProvider
                name="manager"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  :menu-props="{ contentClass: 'notranslate' }"
                  search-input.sync="filterManager"
                  v-model="request.manager_id"
                  :items="community_managers"
                  :loading="userModel.fetching"
                  hide-selected
                  item-text="full_name"
                  item-value="id"
                  label="Select Manager"
                  placeholder="Start typing to Search"
                  :error-messages="errors"
                  class="notranslate"
                  required
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pr-md-7" :lg="rightDrawer.opened ? 12 : 12">
              <ValidationProvider
                name="description"
                rules="required"
                v-slot="{ errors }"
              >
                <vue-editor
                  class="py-6 notranslate"
                  name="description"
                  :error-messages="errors"
                  v-model="request.description"
                  label="Description"
                  required
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pr-md-7">
              <DropZone
                :required="true"
                ref="media"
                :remote-files="project.media.photos"
                :subjectId="project.id"
                subjectType="projects"
                category="photos"
                name="project_photos"
                :allowMultiple="false"
                class=""
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </validation-observer>

    <v-card-actions class="flex-column flex-md-row px-5">
      <v-btn
        large
        color="white"
        class="elevation-1 font-weight-bold px-8 mr-10"
        min-width="275px"
        @click="goToList()"
      >
        Cancel
      </v-btn>
      <v-btn
        large
        color="primary"
        class="elevation-1 font-weight-bold px-8 ml-0 ml-md-2"
        min-width="275px"
        @click.prevent="submit()"
        :loading="request.submitting"
        :disabled="
          request.submitting ||
            project.graduated ||
            (!request.id && request.submitted)
        "
      >
        Done
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Request from '@request/ProjectRequest';
import Model from '@models/Project';
import UserModel from '@models/User';

export default {
  name: 'Create',
  metaInfo: {
    titleTemplate: '%s - Manage Project',
  },
  components: {
    DropZone: () => import('@components/utilities/DropZone'),
    VueEditor: () => import('@components/utilities/VueEditor'),
    LocationField: () => import('@components/utilities/LocationField'),
  },
  beforeRouteEnter(to, from, next) {
    next(async function(vm) {
      vm.fetchCommunityManagers();
    });
  },
  props: {
    customExit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      community_managers: [],
      request: new Request(this.$refs),
      project: {
        media: {
          photos: [],
        },
      },
      model: new Model(),
      userModel: new UserModel({
        page: 1,
        itemsPerPage: -1,
        filters: {
          role: 'community-manager',
        },
      }),
      filterManager: '',
    };
  },
  watch: {
    filterManager() {
      this.fetchCommunityManagers();
    },
  },
  methods: {
    async fetchCommunityManagers() {
      this.userModel.setFilters({
        name: this.filterManager,
      });
      let response = await this.userModel.get();
      if (response) {
        this.community_managers = response.data;
        if (this.project && this.project.manager) {
          let manager = this.project.manager;
          if (!this.community_managers.find((data) => data.id === manager.id)) {
            this.community_managers = this.community_managers.concat([manager]);
          }
        }
      }
    },
    async submit() {
      if (await this.$refs.validator.validate()) {
        let response = await this.request.submit();
        if (response) {
          await this.$refs.media.upload(this.project.id || response.data.id);
          if (!this.request.id) {
            this.goToList(response.data);
          }
        }
      }
    },
    goToList(data) {
      if (this.customExit) {
        this.$emit(this.customExit, data);
        return;
      }
      if (this.$route.from && this.$route.from.name === 'projects') {
        this.$route.back();
        return;
      }
      this.$router.push({
        name: 'projects',
      });
    },
  },
  async mounted() {
    if (this.$route.params.id) {
      let id = this.$route.params.id;
      this.model.addRelation('manager', 'media');
      let response = await this.model.findById(id);
      if (response) {
        let project = response.data;
        Object.assign(this.project, project);
        this.request.reinit(project);
      }
    }
  },
};
</script>

<style scoped></style>
